import { ShiftDetailView } from '@/domains/shifts/components/ShiftDetailView';
import {
  useAssignShift,
  useAssignShiftToTeam,
  useDeleteAssignment,
  useRemoveTeamShift,
  useShift,
  useUpdateShift,
} from '@/domains/shifts/hooks/useShifts';
import { useNavigate, useParams } from 'react-router';

export function ShiftDetailPage() {
  const { shiftId } = useParams<{ shiftId: string }>();
  const navigate = useNavigate();

  const id = shiftId ? Number(shiftId) : null;
  const { data: shift, isLoading } = useShift(id);
  const updateShift = useUpdateShift(id ?? 0);
  const assignShift = useAssignShift();
  const assignShiftToTeam = useAssignShiftToTeam();
  const deleteAssignment = useDeleteAssignment();
  const removeTeamShift = useRemoveTeamShift();

  if (!shiftId) return null;

  return (
    <ShiftDetailView
      shift={shift ?? null}
      isLoading={isLoading}
      onBack={() => navigate('/shifts')}
      onUpdateShift={async (data) => {
        await updateShift.mutateAsync(data);
      }}
      onAssignShift={async (data) => {
        await assignShift.mutateAsync(data);
      }}
      onAssignShiftToTeam={(data) => assignShiftToTeam.mutateAsync(data)}
      onDeleteAssignment={async (assignmentId) => {
        await deleteAssignment.mutateAsync(assignmentId);
      }}
      onRemoveTeamAssignment={async ({ teamId, startDate, endDate }) => {
        if (id === null) return;
        await removeTeamShift.mutateAsync({ teamId, shiftId: id, startDate, endDate });
      }}
    />
  );
}
